// extracted by mini-css-extract-plugin
export default {"experienceDetailsContainer":"ExperienceDetails_experienceDetailsContainer__TvG5f"};